module.exports = __webpack_public_path__ + "media/images/SCO23_mosaic-cffe0c9bdbad6ae166c663706d0bdca8.jpg";